import router from "@/router";
import store from "@/store";
import { reactive, computed, onBeforeMount } from "@vue/composition-api";
// import { dynamicBi } from "@/configs/dynamic-config/dynamic-bi";
import { data } from "@/@fake-db/mock-summary-dash/summary-bi";
import { dynamicTableModel } from "@/models/data-management/dynamic-table";
import { dynamicTable } from "@/configs/dynamic-config/dynamic-table";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function userDataManagementSummary() {
  const {
    openErrorModal,
    openSuccessModal,
    openWarningModal,
    openDefaultErrorModal,
  } = useValidationModal();

  const {
    fetchQueryDisplayModel,
    GetBrandAppDetailModel,
  } = dynamicTableModel();

  const loading = reactive({
    Data: false,
  });

  const DynamicUI = reactive({
    BI: [],
    data: [],
  });

  const dynamicTableConfig = reactive({
    isShow: true,
    displayKey: "",
    queryId: "",
    displayId: "",
    queryDataKey: null,
    isCreate: false,
  });

  const BrandAppDetail = reactive({
    brandid: "",
    app_id: "",
    appid: "",
  });

  const getDisplayKey = () => {
    let data = dynamicTable.config[router.currentRoute.params.ref];
    dynamicTableConfig.displayKey = data.displayKey;
    dynamicTableConfig.queryId = data.queryId;
    dynamicTableConfig.queryDataKey = data.queryDataKey;
    dynamicTableConfig.displayId = data.displayId;
    dynamicTableConfig.isCreate = data.isCreate;
  };

  const summaryDisplay = reactive({
    chartList: [],
  });

  const GetBrandAppDetail = () => {
    return new Promise((resolve, reject) => {
      store
        .dispatch("api/apiRequest", GetBrandAppDetailModel)
        .then((response) => {
          BrandAppDetail.brandid = response.data.brandid;
          BrandAppDetail.app_id = response.data.app_id;
          BrandAppDetail.appid = response.data.appid;

          resolve(response);
        })
        .catch((error) => {
          openDefaultErrorModal(error);
          reject(error);
        })
        .finally(() => {});
    });
  };

  const fetchSummaryDisplay = () => {
    loading.Data = true;

    fetchQueryDisplayModel.payload.Display_Key = dynamicTableConfig.displayKey;

    store
      .dispatch("api/apiRequest", fetchQueryDisplayModel)
      .then((response) => {
        summaryDisplay.chartList = response.data.dynamic_fields;
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.Data = false;
      });
  };

  onBeforeMount(() => {
    DynamicUI.data = data.dynamicbidata;
    getDisplayKey();
    GetBrandAppDetail().then(() => {
      fetchSummaryDisplay();
    });
  });

  return {
    loading,
    summaryDisplay,
    dynamicTableConfig,
    DynamicUI,
    BrandAppDetail,
  };
}
